import Common from '../Common';

class VerifyCodeBase extends Common {}

export default VerifyCodeBase;
